import MAShortSalePage from './MAShortSalePage'
// Uncomment the below to migrate to stateful component
// import MAShortSalePageContainer from './MAShortSalePageContainer'

export { MAShortSalePage }
export default MAShortSalePage
// Uncomment the below to migrate to stateful component
// export { MAShortSalePageContainer }
// export default { MAShortSalePageContainer }
